import React from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';


type Props = {}

/** 코치진 페이지 */
const Staff = (props: Props) => {

    const mock = [
        {
        name: '이승균',
        title: 'CEO | 총감독',
        avatar: 'https://cdn-icons-png.flaticon.com/512/353/353557.png',
        },
        {
        name: '지도자_1',
        title: 'Head Coach | 수석 코치',
        avatar: 'https://cdn-icons-png.flaticon.com/512/353/353557.png',
        },
        {
        name: '지도자_2',
        title: 'Serve Coach | 전담 코치',
        avatar: 'https://cdn-icons-png.flaticon.com/512/353/353557.png',
        },
        {
        name: '지도자_3',
        title: 'Coach | 코치',
        avatar: 'https://cdn-icons-png.flaticon.com/512/353/353557.png',
        },
    ];

    return (
        <>
            <Grid container spacing={2} sx={{ mt: 5, p: 20, '@media (max-width: 1300px)': { mt: 15, p: 3 } }}>
                <Grid item xs={12} lg={12}>
                    <Typography textAlign={'center'} sx={{ fontWeight: 600, fontSize: '1.5em' }}>코치진 소개</Typography>
                </Grid>
                {mock.map((item, i) => (
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={3}
                        key={i}
                        data-aos={'fade-up'}
                    // data-aos-delay={i * 100}
                    // data-aos-offset={100}
                    // data-aos-duration={600}
                    >
                        <Box 
                        component={Card} 
                        boxShadow={0} 
                        bgcolor={'transparent'} 
                        sx={{
                            transition: 'all .2s ease-in-out',
                            boxShadow: 'rgba(0, 0, 0, 0.1) 1px 10px 20px',
                            borderRadius: '10px',
                            '&:hover': {
                            transform: 'translateY(-20px)',
                            boxShadow: 'rgba(0, 0, 0, 0.1) 3px 50px 30px',
                            borderRadius: '10px'
                            }
                        }}>
                        <Box
                            component={CardMedia}
                            borderRadius={2}
                            width={1}
                            height={1}
                            minHeight={320}
                            image={item.avatar}
                        />
                        <CardContent>
                        <ListItemText
                            primary={item.name}
                            secondary={item.title}
                            primaryTypographyProps={{ fontWeight: 700 }}
                        />
                        </CardContent>
                    </Box>
                    {/* <Box 
                        component={Card} 
                        boxShadow={0} 
                        bgcolor={'transparent'} 
                        sx={{ 
                            transition: 'all .2s ease-in-out',
                            '&:hover': {
                            transform: 'translateY(-20px)',
                            boxShadow: 5,
                            borderRadius: '10px'
                            }
                        }}>
                        <Box
                            component={CardMedia}
                            borderRadius={2}
                            width={1}
                            height={1}
                            minHeight={320}
                            image={item.avatar}
                        />
                        <CardContent>
                        <ListItemText
                            primary={item.name}
                            secondary={item.title}
                            primaryTypographyProps={{ fontWeight: 700 }}
                        />
                        
                        </CardContent>
                    </Box> */}
                    </Grid>
                ))}
                </Grid>
        </>
    )
}

export default Staff